import {
  ToolbarConfigOptions,
  ToolbarConfig,
  ToolbarComponentTypes,
  ToolbarControlComponentTypes,
  COMMON_PDF_PRINT_BUTTON_CELL_TAG
} from 'src/app/configs/model/finra-toolbar.model';

export const TraceToolbarConfig = (
  config: ToolbarConfigOptions
): ToolbarConfig => ({
  description: config.description,
  rows: [
    // first row
    {
      rowClass: 'display-flex flex-space-between',
      components: [
        {
          cellClass: 'display-flex',
          components: [
            {
              cellClass: 'margin-right-30',
              component: {
                type: ToolbarComponentTypes.LABEL,
                label: config.firmNameLabel,
                value: config.firmNameValue,
                labelId: 'firmName',
              }
            },
            {
              cellClass: 'margin-right-30',
              component: {
                type: ToolbarComponentTypes.LABEL,
                label: config.firmIdLabel,
                value: config.firmIdValue,
                labelId: 'firmId'
              }
            }
          ]
        },
        {
          cellClass: 'display-flex',
          components: [
            {
              cellClass: 'help-btn margin-right-30',
              component: {
                type: ToolbarComponentTypes.BUTTON,
                buttonLabel: 'Help',
                buttonIcon: config.helpIcon,
                buttonIconClass: '',
                buttonClass: '',
                clickHandler: config.setHelpClickHandler,
              }
            },
            {
              cellClass: 'help-btn margin-right-30',
              hideCell: config.hidePeerGroupHelpButton,
              component: {
                type: ToolbarComponentTypes.BUTTON,
                buttonLabel: 'Help (Peer Group Definition)',
                buttonIcon: config.helpIcon,
                buttonIconClass: '',
                buttonClass: '',
                clickHandler: config.setPeerGroupDefinitionHelpClickHandler,
              }
            },
            {
              cellClass: 'pdf-btn',
              cellTag: COMMON_PDF_PRINT_BUTTON_CELL_TAG,
              component: {
                type: ToolbarComponentTypes.BUTTON,
                buttonLabel: 'Print',
                buttonIcon: config.pdfIcon,
                buttonIconClass: '',
                buttonClass: '',
                clickHandler: null,
              }
            }
          ]
        },
      ]
    },
    // second row
    {
      rowClass: 'display-flex flex-space-between',
      components: [
        {
          cellClass: 'display-flex field-row-group',
          components: [
            {
              cellClass: 'margin-right-30 field-period-container',
              component: {
                type: ToolbarComponentTypes.CONTROL,
                controlType: ToolbarControlComponentTypes.SELECT,
                controlLabel: 'Period:',
                dataList: config.periods,
                formControl: config.periodFormControl,
                formControlClass: '',
                displayPipeFilter: 'date-month-year',
                formControlName: 'period',
              }
            },
            {
              cellClass: 'margin-right-30 field-version-container',
              component: {
                type: ToolbarComponentTypes.CONTROL,
                controlType: ToolbarControlComponentTypes.SELECT,
                controlLabel: 'Version:',
                dataList: config.versions,
                formControl: config.versionFormControl,
                formControlClass: '',
                formControlStyle: { width: '50px' },
                formControlName: 'version',
              }
            },
            {
              cellClass: 'margin-right-30 field-view-container',
              hideCell: config.hideViewsCell,
              component: {
                type: ToolbarComponentTypes.CONTROL,
                controlType: ToolbarControlComponentTypes.SELECT,
                controlLabel: 'View:',
                dataList: config.reportName === 'traceqmrcmumd' ? ['Mark-Up', 'Mark-Down', 'Spread'] : config.views,
                formControl: config.viewFormControl,
                formControlClass: '',
                formControlStyle: { width: '150px' },
                formControlName: 'viewName',
                displayPipeFilter: 'viewName'
              }
            },
            {
              cellClass: 'margin-right-30',
              hideCell: config.hidePublishedState,
              component: {
                type: ToolbarComponentTypes.LABEL,
                label: 'Show',
                value: config.publishedState,
                labelId: 'showPublishedLabel'
              }
            },
            {
              cellClass: '',
              component: {
                type: ToolbarComponentTypes.BUTTON,
                buttonLabel: 'Go',
                buttonIcon: null,
                buttonIconClass: '',
                buttonClass: '',
                clickHandler: config.changeClickHandler,
              }
            }
          ]
        },
        {
          cellClass: 'display-flex',
          components: [
            {
              cellClass: config.hideDetailsButton ? '' : 'margin-right-30',
              hideCell: config.shouldHideSummaryExportButton,
              cellId: 'summary-export-button',
              component: {
                type: ToolbarComponentTypes.BUTTON,
                buttonLabel: 'Summary',
                buttonIcon: config.summaryIcon,
                buttonIconClass: '',
                buttonClass: '',
                buttonId: 'summaryDataLink',
                clickHandler: config.summaryExportClickHandler
              }
            },
            !config.isMarkupMarkdownReport
              ?
            {
              cellClass: '',
              hideCell: config.hideDetailsButton,
              cellId: 'detail-export-button',
              component: {
                type: ToolbarComponentTypes.BUTTON,
                buttonLabel: 'Details',
                buttonIcon: config.detailsIcon,
                buttonIconClass: '',
                buttonClass: '',
                clickHandler: config.detailsClickHandler,
                buttonId: 'detailDataLink',
              }
            } :
            {
              cellClass: '',
              cellId: 'detail-all-export-button',
              component: {
                type: ToolbarComponentTypes.BUTTON,
                buttonLabel: 'Details (All)',
                buttonIcon: config.detailsIcon,
                buttonIconClass: '',
                buttonClass: '',
                clickHandler: config.detailsAllClickHandler,
                buttonId: 'detailAllDataLink',
              }
            }
          ],
        }
      ]
    },
    // third row
    {
      rowClass: 'display-flex flex-space-between',
      hideRow: !config.isMarkupMarkdownReport,
      components: [
        {
          cellClass: 'display-flex',
          components: [
            {
              cellClass: 'margin-right-30 field-maturity-container',
              component: {
                type: ToolbarComponentTypes.CONTROL,
                controlType: ToolbarControlComponentTypes.SELECT,
                controlLabel: 'Maturity:',
                dataList: config.maturitiesList,
                formControl: config.maturityFormControl,
                formControlClass: '',
                formControlStyle: { width: '100px' },
                useObjectDisplayProperty: true,
                useObjectValueProperty: true,
                displayProp: 'name',
                valueProp: 'value',
                formControlName: 'maturity',
              }
            },
            {
              cellClass: 'margin-right-30 field-rating-container',
              component: {
                type: ToolbarComponentTypes.CONTROL,
                controlType: ToolbarControlComponentTypes.SELECT,
                controlLabel: 'Rating:',
                dataList: config.ratingsList,
                formControl: config.ratingFormControl,
                formControlClass: '',
                formControlStyle: { width: '200px' },
                useObjectDisplayProperty: true,
                useObjectValueProperty: true,
                displayProp: 'name',
                valueProp: 'value',
                formControlName: 'rating',
              }
            },
            {
              cellClass: 'margin-right-30 field-product-container',
              component: {
                type: ToolbarComponentTypes.CONTROL,
                controlType: ToolbarControlComponentTypes.SELECT,
                controlLabel: 'Product:',
                dataList: config.productsList,
                formControl: config.productFormControl,
                formControlClass: '',
                formControlStyle: { width: '200px' },
                useObjectDisplayProperty: true,
                useObjectValueProperty: true,
                displayProp: 'name',
                valueProp: 'value',
                formControlName: 'product',
              }
            },
          ],
        },
        {
          cellClass: 'display-flex',
          components: [
            {
              cellClass: '',
              hideCell: !config.isMarkupMarkdownReport,
              cellId: 'detail-export-button',
              component: {
                type: ToolbarComponentTypes.BUTTON,
                buttonLabel: 'Details (By View)',
                buttonIcon: config.detailsIcon,
                buttonIconClass: '',
                buttonClass: '',
                clickHandler: config.detailsClickHandler,
                buttonId: 'detailDataLink',
              }
            },
          ],
        }
      ]
    }
  ]
});
